export default "__VITE_ASSET__Bn6I8UzU__"